// Mapped to: https://github.com/CatchoftheDay/cotd-website/blob/f296b27860aa657d1bb79d7af6d390c1b35b32db/src/Cotd/EntityBundle/Entity/Platform.php#L14:L18
export var SourcePlatform;

(function (SourcePlatform) {
  SourcePlatform[SourcePlatform["WEB"] = 1] = "WEB";
  SourcePlatform[SourcePlatform["MOBILE_WEB"] = 2] = "MOBILE_WEB";
  SourcePlatform[SourcePlatform["IPAD"] = 3] = "IPAD";
  SourcePlatform[SourcePlatform["ANDROID"] = 4] = "ANDROID";
  SourcePlatform[SourcePlatform["IPHONE"] = 5] = "IPHONE";
})(SourcePlatform || (SourcePlatform = {}));